import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UtilService, VariablesService } from 'src/app/shared/services';
import { MatMenuModule } from '@angular/material/menu';
import { MatRippleModule } from '@angular/material/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

interface IErrors {
  required?: string;
  minlength?: string;
  maxlength?: string;
  min?: string;
  max?: string;
  email?: string;
  password?: string;
  pattern?: string;
  custom?: string;
}

@Component({
  selector: 'app-phone-number-input-v2',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatMenuModule, MatRippleModule, SharedModule, MatFormFieldModule, MatInputModule, MatIconModule],
  templateUrl: './phone-number-input-v2.component.html',
  styleUrls: ['./phone-number-input-v2.component.scss']
})
export class PhoneNumberInputV2Component {
  @Input() isUserForm?: boolean = false;
  @Input() group?: FormGroup;
  @Input() control?: FormControl;
  @Input() inputId?: string = '';
  @Input() theme?: string = '';
  @Input() label: string = '';
  @Input() note: string = '';
  @Input() placeHolder = '';
  @Input() showEdit: boolean = false;
  @Input() showIcon?: boolean;
  @Input() hideSuffix?: boolean;
  @Input() errorMessage?: IErrors;
  @Input() customClass?: string;
  @Input() disabled = false;
  @Input() defaultDialCode;
  @Input() selectedCountry;
  @Output() numberEmit = new EventEmitter();
  @Output() onCountryChange = new EventEmitter();
  @Output() onEditClick = new EventEmitter();
  @Output() onFocus = new EventEmitter();

  @ViewChild('childInput') childInput?: ElementRef;

  allCountries: any[];

  iti: any;
  checkIntlTelErrorSubs: any;
  isValid: any;
  firstLoad = true;
  focused = false;
  isMobile = false;
  defaultCode = 'in';
  inputValue = '';

  constructor(
    private util: UtilService,
    public vars: VariablesService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.util.isMobile();
    this.loadCountries();
    this.control.valueChanges.subscribe(val => {
      this.handleValueChange(val);
    });
  }

  loadCountries() {
    if (!this.vars.countryList) {
      setTimeout(() => {
        this.loadCountries();
      }, 100);
      return;
    }
    this.allCountries = this.vars.countryList;
    const selected_mobile_code = this.util.storage.getFromSession('selected_mobile_code');
    const clientLocationData = this.vars.clientLocationData.getValue();
    let initCountry = this.allCountries.filter(val => val.code === (selected_mobile_code || clientLocationData?.country_code?.toLowerCase() || this.defaultCode))[0];
    if (this.defaultDialCode) {
      initCountry = this.allCountries.filter(val => val.dialCode === this.defaultDialCode)[0];
    }
    this.setCountry(this.selectedCountry || initCountry);
  }

  handleValueChange(val: string) {
    if (this.vars.isAutoLogin && val.includes('*') && this.selectedCountry?.pattern?.test(val.replaceAll('*', '1'))) {
      this.inputValue = val;
      return;
    }
    let cleaned = val?.replace(/\D/g, '');
    if (cleaned?.startsWith('00')) {
      cleaned = cleaned?.replace(/^00/, '0');
    }
    cleaned = cleaned?.slice(0, 16);
    if (val !== cleaned) {
      this.control.setValue(cleaned);
      return;
    }
    this.inputValue = val;
  }

  setCountry(item) {
    this.selectedCountry = item;
    this.onCountryChange.emit(item);
    if (!this.firstLoad) {
      setTimeout(() => {
        this.childInput?.nativeElement?.focus();
      }, 100);
    }
    this.firstLoad = false;
    this.util.storage.addSessionData('selected_mobile_code', item?.code || this.defaultCode);
  }

  focusInput(e?: any) {
    this.focused = e;
    this.onFocus.emit(e);
  }
}
